import type { Tokens } from '../../../../theming/types'
import { styles } from '../../../../utilities'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      fieldset: {
        border: 0,
        margin: 0,
        minWidth: 0,
        padding: '0.01em 0 0 0',

        '& > &, .selectionControlGroupNestedWrap': {
          marginInlineStart: '32px',
        },

        '.selectionControlGroupItemBottomMargin': {
          marginBottom: '8px',
        },
      },

      legend: {
        ...tokens.fontElementLabel,
        color: tokens.fontColorDefault,
      },
    },

    disabled: {
      legend: {
        color: tokens.form.disabledTextColor,
      },
    },

    hiddenLegend: {
      display: 'block',
    },

    hidden: styles.visuallyHidden,
  } as const
}
